export default {
  jsonHotel: state => state.jsonHotel,
  jsonRooms: state => state.jsonRooms,
  hotel: state => state.hotel,
  nearbyHotels: state => state.nearbyHotels,
  bookingStayInProgress: state => state.bookingStayInProgress,
  customer: state => state.customer,
  staysHasBeenLoading: state => state.staysHasBeenLoading,
  exchangeRates: state => state.exchangeRates,
  currenciesList: state => state.currenciesList,
  tripAdvisorHotelInfo: state => state.tripAdvisorHotelInfo,
  labelsLoaded: state => state.labelsLoaded,
  loyaltyConsentAccepted: state => state.loyaltyConsentAccepted,
  filter: state => state.filter,
  filteredHotel: state => state.filteredHotel,
  taxIncludedRegion: state => state.taxIncludedRegion,
  taxExcludedRegion: state => state.taxExcludedRegion,
  isUk: state => state.isUk,
  error: state => state.error,
  getMembersBenefits: state => state.membersBenefits,
  getDataQubit: state => state.dataQubit,
  getSearchData: state => {
    return {
      adults: state.adults,
      children: state.children,
      guests: state.guests,
      rooms: state.rooms,
      checkinDate: state.checkinDate,
      checkoutDate: state.checkoutDate
    }
  },
  getToggleSwitch: state => state.toggleGroup,
  getNonMemberRate: state => state.nonMemberRate,
  getTabSelected: state => state.tabSelected
}
